<template>
  <div class="search-image-header">
    <div class="img-box">
      <img :src="currentItem.params.keyword || 'https://www.yiyuen.com/e/file/view/390346'" />
    </div>
    <div class="input-box">
      <a-space direction="vertical">
        <a-textarea
          style="width: 840px; font-size: 12px"
          v-model:value="imgUrls"
          placeholder="请输入图片链接，一行一个，一次最多【200】个链接"
          :rows="4"
          allowClear
        />
        <a-space>
          <a-upload
            accept="image/*"
            name="file"
            :showUploadList="false"
            :customRequest="handleChange"
            :before-upload="beforeUpload"
            :multiple="true"
          >
            <a-button type="primary" style="width: 140px; font-size: 15px" @click="initUpLoadImg">
              <UploadOutlined />上传图片
            </a-button>
          </a-upload>
          <a-button type="primary" style="width: 140px; font-size: 15px" @click="startSearchImg()">
            <SearchOutlined />搜索
          </a-button>
          <FilterOption
            ref="filterOption"
            v-show="currentPlatformType === 'ali'"
            @changeSort="changeSort"
            @changeFilter="changeFilter"
          />
        </a-space>
        <slot></slot>
      </a-space>
      <div v-show="fileList.length > 1" class="top-box">
        <div
          v-for="(item, index) in fileList"
          :key="index"
          :class="{
            item: true,
            active: index == imgIndex,
            'is-selected': item.platformInfo[`${currentPlatformType}_info`]?.selectedList?.length,
          }"
          @click="changeClue(index)"
        >
          {{ +index + 1 }}
          <span
            v-if="item.platformInfo[`${currentPlatformType}_info`]?.selectedList?.length"
            class="is-selected-icon"
          ></span>
        </div>
      </div>
      <div v-show="fileList.length > 1" style="font-size: 14px">
        选品进度：{{ getSelectCount() }} / {{ fileList.length }}&nbsp;&nbsp;
        <a-space>
          <a-button
            type="primary"
            size="small"
            ghost
            :disabled="imgIndex === 0"
            @click="changeClue(-2)"
            @keyup.enter="changeClue(-2)"
            >上一个</a-button
          >
          <a-button
            type="primary"
            size="small"
            ghost
            :disabled="imgIndex === fileList.length - 1"
            @click="changeClue(-1)"
            @keyup.down="changeClue(-1)"
            >下一个</a-button
          >
        </a-space>
      </div>
    </div>
  </div>
</template>
<script>
import FilterOption from "../filter_option";
import { SearchOutlined, UploadOutlined } from "@ant-design/icons-vue";
import handler from "./handler";
export default {
  components: { SearchOutlined, UploadOutlined, FilterOption },
  data() {
    return {
      currentItem: {
        value: "searchImage",
        msg: "请先上传一张图片",
        placeholder: "可输入图片链接，点击【搜索】按钮搜索商品",
        platformInfo: {},
        isCheckAll: false,
        params: {
          keyword: "",
          page: 1,
          size: 100,
        },
      },
      fileList: [],
      imgUrls: ``,
      imgIndex: 0,
    };
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    currentPlatformType: String,
    platformList: Array,
  },
  computed: {
    getFileListLength() {
      return this.fileList.length;
    },
  },
  methods: {
    //切换排序时触发
    changeSort(e) {
      this.$emit("changeSort", e);
    },
    // file 转 base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    initUpLoadImg(isNotClearImgUrls) {
      this.fileList = [];
      if (!isNotClearImgUrls) this.imgUrls = "";
      for (var key in this.currentItem.platformInfo) {
        var info = this.currentItem.platformInfo[key];
        info.list = [];
        info.selectedList = [];
        info.total = 0;
      }
    },
    // 上传前先验证是否通过
    beforeUpload(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) this.$message.error("您上传的图片格式不对");
      return isJpgOrPng;
    },
    // 上传成功后执行
    handleChange(obj) {
      var newItem = JSON.parse(JSON.stringify(this.params));
      var keyword = URL.createObjectURL(obj.file);
      this.imgUrls = this.imgUrls ? (this.imgUrls = `${this.imgUrls}\n${keyword}`) : keyword;
      newItem.params.keyword = keyword;
      this.fileList.push(newItem);
    },
    startSearchImg() {
      if (!this.imgUrls.trim()) return this.$message.warn("请输入需要搜索的图片链接");
      const count = this.imgUrls.split("\n");
      if (count?.length > 200) return this.$message.warning(`一次最多支持【200】个, 当前有【${count.length}】个链接`);
      this.initUpLoadImg(true);
      this.fileList = handler.FillFileListByImgUrls(this.imgUrls, this.currentItem);
      this.currentItem = this.fileList[0];
      this.imgIndex = 0;
      this.searchGoods(true);
    },
    searchGoods(isReload) {
      if (!this.currentItem.params.keyword) return this.$message.warning("请先上传一张图片");
      this.$emit("searchGoods", this.currentItem, isReload);
    },
    changeClue(index) {
      debugger;
      // -1 是【下一个】
      if (index === -1) index = ++this.imgIndex;
      // -2 是【上一个 】
      else if (index === -2) index = --this.imgIndex;
      this.currentItem = this.fileList[index];
      this.imgIndex = index;
      // 如果有了就不重新搜图
      this.searchGoods();
    },
    ClearAllChecked() {
      // 图片
      this.fileList.forEach((item) => {
        // 平台
        for (var key in item.platformInfo) {
          var info = item.platformInfo[key];
          // 选中项数组
          info.selectedList = [];
          info.list.forEach((item2) => {
            item2.selected = false;
          });
        }
      });
    },
    getSelectCount() {
      var count = 0;
      this.fileList.forEach((item) => {
        for (var key in item.platformInfo) {
          var itemSelectedList = item.platformInfo[key].selectedList;
          if (!itemSelectedList.length) continue;
          count++;
          break;
        }
      });
      return count;
    },
    handleKeydown(event) {
      var keyCode = event.keyCode;
      var index = 0;
      if (keyCode == 40 && this.imgIndex != this.fileList.length - 1) index = -1; // 下一个
      if (keyCode == 38 && this.imgIndex) index = -2; // 上一个
      if (!index) return;
      this.changeClue(index);
    },
    changeFilter() {
      this.$emit("searchGoods", this.currentItem, true);
    },
  },
  mounted() {
    this.currentItem = JSON.parse(JSON.stringify(this.params));
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  watch: {
    getFileListLength: {
      handler(newVal) {
        // 如果0 说明没有图片, 如果1说明是有, 如果大于1说明在添加, 只进行所有第一张,
        if (newVal != 1) return;
        this.currentItem = this.fileList[0];
        this.imgIndex = 0;
        this.searchGoods(true);
      },
    },
  },
};
</script>
<style scoped lang="less">
.search-image-header {
  display: flex;
  .img-box {
    width: 145px;
    height: 145px;
    margin-right: 0.7em;
    > img {
      width: 145px;
      height: 145px;
      border-radius: 4px;
      border: 1px solid #ddd;
    }
  }
  .input-box {
    display: flex;
    flex-direction: column;
    :deep(.ant-input) {
      font-size: 15px;
    }
  }
  .top-box {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    max-height: 120px;
    overflow: auto;
    > .item {
      width: 45px;
      height: 21px;
      line-height: 21px;
      margin-bottom: 3px;
      text-align: center;
      background: #f8f0f0;
      border-radius: 5px;
      margin-right: 3px;
      cursor: pointer;
      position: relative;
      .is-selected-icon {
        position: absolute;
        right: 2px;
        top: 0;
        font-size: 22px;
        transform: rotate(15deg);
      }
      &.is-selected {
        background: #c8f2ed;
      }
      &.active {
        color: #fff;
        background: #2eb6a8;
        .is-selected-icon {
          color: #fff;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
